import React, { Fragment, useCallback } from 'react';
import SideNavItem from './SideNavItem';
import { NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as actions from '../../actions';


function convertFunctionsToMenu(functions)	{
	let sideMenu = [];
	functions.forEach(f => {
		let main = {};
		main.id = f.functionNo;
		main.name = f.functionName;
		main.subList = []
		f.functions.forEach(fs => {
			let sub = {};
			sub.functionNo = fs.functionNo;
			sub.name = fs.functionName;
			sub.path = fs.functionUrl; 
			if (sub.path === null) sub.path = '';
			
			main.subList.push(sub);
		});
		sideMenu.push(main);
	});
	return sideMenu;
}

const SideNav = props => {
	const dispatch = useDispatch();
    const logout = useCallback(() => dispatch(actions.logout()), [dispatch]);
	const userFunctions = JSON.parse(sessionStorage.getItem('user')).user.userFunctions;
	const functions = userFunctions.filter(f => (f.functionNo !== 'RT' && f.functionNo !== 'PH'));
		
	const sideMenu = convertFunctionsToMenu(functions);

    return (
        <Fragment>
            <div className="menu-bg"></div>
            <div className="navbar-collapse collapse" id="navbar-main">
                <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                    <div className="panel panel-default">
                        {
                            sideMenu.map((item, index) => <SideNavItem key={index} {...item} />)
                        }
                        <div id="OTCollapse">
							<div role="tab" id="for-mobile">
								<a className="list-group-item" data-toggle="collapse" data-parent="#accordion"
									href='#for-mobile-list' aria-expanded="true" aria-controls='for-mobile-list'>
									個人功能
								</a>
							</div>
							<div id='for-mobile-list' className="panel-collapse collapse " role="tabpanel" aria-labelledby='for-mobile'>
								<ul className="list-group">
									<li><NavLink className='menu-list' to="/OperationManual"  data-toggle="collapse" data-target="#navbar-main" aria-expanded="true">操作手冊</NavLink></li>
									<li><NavLink className='menu-list' id="oacVideo" to="#!"  data-toggle="collapse" data-target="#navbar-main" aria-expanded="true">教學影片</NavLink></li>
									<li><NavLink className='menu-list' to="/PersonDataMaintain"  data-toggle="collapse" data-target="#navbar-main" aria-expanded="true">個人資料維護</NavLink></li>
									<li><a className="menu-list" href="/#" onClick={logout}  data-toggle="collapse" data-target="#navbar-main" aria-expanded="true">登出</a></li>
								</ul>
							</div>
	                    </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default SideNav;